import configs from "constants/configs";
import React, { useState, useCallback, useEffect } from "react";
import Dropzone from "react-dropzone";
import { pushNotification } from "utils/notifications";

const UploadMultiFile = (props) => {
  let { Files, onChange, Code, readOnly } = props;
  let [files, setFiles] = useState(Files ? Files : []);
  let [file, setFile] = useState("");
  let [isLoad, setLoad] = useState("");

  useEffect(() => {
    if (typeof Files != "undefined") {
      if (Files.length == 0 && Files.length != files.length) {
        setFiles([]);
      }

      const lstFile = Files.filter((item) => item !== "");
      const newFile = lstFile.map((item, index) => {
        if (typeof item.url === "undefined" && item !== "") {
          const link = {
            Name: item.substr(item.lastIndexOf("/") + 1),
            url: item,
          };
          if (link.url.lastIndexOf("/Upload/TaiSanImage/") !== -1) {
            link.view = "https://hi.morman.vn/" + link.url;
          } else if (
            link.url.lastIndexOf("http") == -1 &&
            link.url.lastIndexOf("/Upload/TaiSanImage/") == -1
          ) {
            link.view = configs.apiViewUpload + link.url;
          } else {
            link.view = link.url;
          }

          return link;
        }
        return item;
      });
      if (newFile.length != files.length && newFile.length > 0) {
        setFiles(newFile);
        setLoad(false);
      }
    }
  }, [props.Files]);
  const onDrop = useCallback(
    (acceptedFiles) => {
      for (let index = 0; index < acceptedFiles.length; index++) {
        const element = acceptedFiles[index];
        const formData = new FormData();
        formData.append("File", element);

        fetch(
          configs.apiUpload +
            "api/uploadfile/UploadImage?sCode=" +
            Code +
            "&sDuAn=Morman",
          {
            method: "POST",
            body: formData,
          },
        )
          .then((response) => response.json())
          .then((result) => {
            if (result.Error === null) {
              const link = {
                Name: result.FileName,
                url: result.FilePath,
                view: configs.apiViewUpload + result.FilePath,
              };
              files.push(link);
              setFiles(files);
              onChange(files);
              setFile(link);
            } else {
              pushNotification(result.Error, "warning", "TOP_RIGHT", 2000);
            }
          })
          .catch((error) => {});
      }
    },
    [files, onChange],
  );

  const xoaFile = useCallback(
    (index, event) => {
      files.splice(index, 1);
      onChange(files);
      if (files.length == 0) {
        setFiles([]);
      } else {
        setFiles(files);
      }
      setFile(file ? "" : index);
    },
    [files, file, onChange],
  );
  const dowloadFile = useCallback();
  return (
    <div
      className="image-property"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: files.length === 0 ? "center" : "flex-start",
      }}
    >
      <Dropzone onDrop={onDrop}>
        {({ getRootProps, getInputProps, open }) => (
          <section>
            {
              <>
                <div
                  {...getRootProps({ className: "dropzone" })}
                  style={
                    files.length !== 0
                      ? { position: "absolute", width: "100%" }
                      : {}
                  }
                >
                  <input {...getInputProps()} />
                  <p style={{ paddingTop: "30px" }}>
                    <div className="row" style={{ justifyContent: "center" }}>
                      <img
                        src="/app-assets/images/icon-upload-image-v2.png"
                        style={
                          files.length !== 0 ? { visibility: "hidden" } : {}
                        }
                      />
                    </div>
                    <div className="row upload-mb">
                      <span
                        style={{
                          color: "#00B69B",
                          fontWeight: "bold",
                          fontSize: "19px",
                        }}
                      >
                        {files.length === 0 ? "Bấm tải ảnh" : " "}
                      </span>
                      <span
                        style={{
                          color: "#525252",
                          fontWeight: "bold",
                          fontSize: "19px",
                        }}
                      >
                        &nbsp;{" "}
                        {files.length === 0 ? "Hoặc kéo thả ảnh tại đây" : " "}
                      </span>
                    </div>
                    <div className="row" style={{ justifyContent: "center" }}>
                      <span>
                        {" "}
                        &nbsp;{" "}
                        {files.length === 0
                          ? "JPG, JPEG, PNG nhỏ hơn 1MB"
                          : " "}{" "}
                      </span>
                    </div>
                  </p>
                </div>
                <div className="itemImgTaiSan" style={{ marginTop: "10px" }}>
                  {files &&
                    files.map((item, index) => (
                      <div key={index} id="item-img2_1" className="item-img ">
                        <a href={item.view} data-fancybox="images">
                          <div
                            className="col-md-2 no-image main-slider"
                            id="main-slider1"
                          >
                            <img
                              className="img-taisan"
                              src={item.view}
                              alt=""
                              style={{ width: "100px", height: "100px" }}
                            />
                          </div>
                        </a>
                        {!readOnly && (
                          <span
                            title="Xóa file"
                            className="xoa"
                            onClick={() => xoaFile(index)}
                          >
                            <i className="la la-close"></i>
                          </span>
                        )}
                      </div>
                    ))}
                </div>
              </>
            }
          </section>
        )}
      </Dropzone>

      <input type="text" className="hidden" value={file} />
    </div>
  );
};
export default UploadMultiFile;
